



























import Vue from "vue"
import DoubleButtonFloatingFrame from "~/components/custom/buttonFrame/DoubleButtonFloatingFrame.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"

export default Vue.extend({
  components: {
    DoubleButtonFloatingFrame,
    ConversionButton,
  },
  props: {
    hasBottomMarginForMobileNavBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShownSignUpModal: false,
    }
  },
  methods: {
    goToInquiryForm() {
      window.open(
        "https://crowdlinks.jp/client/form/contact/?from=inside_service",
        "_blank"
      )
    },
    openSignupPage() {
      window.location.href = `${process.env.FRONTEND_WORKER_BASE_URL}/worker/signup/`
    },
  },
})
